import { a as e, c as t, o as n, s as r, t as i, u as a } from "./types-C27lFQz7.js";
import { createBlock as o, createCommentVNode as s, createElementBlock as c, createElementVNode as l, createVNode as u, defineAsyncComponent as d, defineComponent as f, onBeforeMount as p, openBlock as m, ref as h, toDisplayString as g, unref as _, withCtx as v } from "vue";
import { BfBrandIcon as y, getBaseUrlForBrand as b, getI18n as x } from "@editor/ui-utils";
import { QBtn as S, QIcon as C, QImg as w } from "quasar";
import { useI18n as T } from "vue-i18n";
import { EditorImagePlaceholder as E, getImageUrl as D } from "@modules/image-editor-ui-components";
import { defineStore as O } from "pinia";
import { stringSanitizers as k } from "@utils/string-utils";
//#endregion
//#region src/lang/index.ts
var A = {
	en: {
		peopleProfile: {
			firstName: "First name",
			lastName: "Last name",
			birthDate: "Date of birth",
			deathDate: "Date of death",
			birthPlace: "Place of birth",
			size: "Size (cm)",
			zodiacSign: "Zodiac sign",
			zodiacSigns: {
				aquarius: "Aquarius",
				pisces: "Pisces",
				aries: "Aries",
				taurus: "Taurus",
				gemini: "Gemini",
				cancer: "Cancer",
				leo: "Leo",
				virgo: "Virgo",
				libra: "Libra",
				scorpio: "Scorpio",
				sagittarius: "Sagittarius",
				capricorn: "Capricorn"
			}
		},
		tagsApi: {
			createAlreadyExists: "The tag cannot be created because another tag with this name already exists.",
			updateAlreadyExists: "The tag cannot be updated because another tag with this name already exists.",
			created: "Tag created",
			updated: "Tag updated",
			notFound: "Tag not found",
			requiredFields: "The tag cannot be saved as mandatory information is missing."
		},
		tagsList: {
			newButton: "New tag",
			name: "Search by tag title",
			deleteTag: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading Tag",
			headerLabel: "Tag",
			headerRelatedTags: "Linked tags",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			headerPublishedAt: "Publish date",
			headerTagType: "Type",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createTag: "Create tag",
			headerStatus: "Status",
			type: "Type",
			noEditTooltip: "This tag is originally from the {source} editor."
		},
		tags: {
			tagsLabel: "Tag",
			backButton: "To tag list",
			newTag: "New tag",
			messageDeleteTag: "Delete tag",
			messageDeleteTagTitle: "Are you sure you want to delete this tag?",
			deleteTag: "Delete",
			messageDeleted: "Tag deleted",
			errorOnDeleting: "Error deleting the tag",
			errorFailedLoadedTagWithId: "Error getting the tag",
			handledInLegacySystem: "This tag is being handled in {source}. It cannot be edited in Vibe.",
			peopleTab: "Edit person",
			profile: "Profile",
			imageSelector: "Select or upload image"
		},
		tagsEdit: {
			title: "Tag title",
			type: "Tag type",
			counter: "Counter",
			backButton: "To tag list",
			editTag: "Edit tag",
			messageSaved: "Tag saved",
			linkTags: "Link tags",
			urlSlug: "URL slug",
			pathConflictNotice: {
				template: "This path is in conflict with {pathType} path of another tag. Only {pathRoutable} tag will be reachable!",
				pathTypeCurrent: "the current",
				pathTypeOld: "an old",
				pathRoutableThis: "this",
				pathRoutableOther: "the other"
			},
			toTag: "To tag",
			generatePath: "Automatically generate path",
			showOnListPage: "Show on overview page",
			publishSettings: "Puhlishing settings",
			publishDate: "Publish date",
			unpublishDate: "Unpublish date",
			shownDate: "Display date",
			deleteTag: "Delete",
			duplicateTag: "Duplicate",
			duplicateTagMessage: "Are you sure you want to duplicate this tag?",
			duplicate: "Duplicate",
			takeOffline: "Unpublish",
			selectTag: "Select tag",
			nowLabel: "Set to now",
			saveAsDraft: "Save as draft",
			updateShownDate: "Update display date",
			updateShownDatePopup: "Automatically update the display date to the current timestamp when you save or publish the article.",
			modeUnpublished: "Tag unpublished",
			modeScheduled: "Publish date scheduled",
			modePublished: "Published",
			modeDraft: "Draft"
		},
		tagsMigration: {
			directEditNotice: "Please note: The settings visible here take effect immediately and are independent of the save function.",
			source: "Source system",
			legacyId: "Legacy ID",
			renderedByCtf: "Rendered by CTF",
			editableInCtf: "Editable in Vibe",
			modifiedInCtf: "Modified in Vibe",
			confirmModal: {
				yes: "Yes",
				cancel: "Cancel",
				renderedBy: {
					title: "Change toggle \"Rendered by CTF\"",
					message: "Are you sure you want to change the rendering system?"
				},
				editableIn: {
					title: "Change toggle \"Editable in Vibe\"",
					message: "Are you sure you want to make the channel editable in CTF? This cannot be undone!"
				}
			},
			viewCtfVersion: "View CTF version"
		},
		tagType: {
			people: "Person",
			brand: "Brand"
		}
	},
	de: {
		peopleProfile: {
			firstName: "Vorname",
			lastName: "Nachname",
			birthDate: "Geburtsdatum",
			deathDate: "Todesdatum",
			birthPlace: "Geburtsort",
			size: "Größe (cm)",
			zodiacSign: "Sternzeichen",
			zodiacSigns: {
				aquarius: "Wassermann",
				pisces: "Fische",
				aries: "Widder",
				taurus: "Stier",
				gemini: "Zwillinge",
				cancer: "Krebs",
				leo: "Löwe",
				virgo: "Jungfrau",
				libra: "Waage",
				scorpio: "Skorpion",
				sagittarius: "Schütze",
				capricorn: "Steinbock"
			}
		},
		tagsApi: {
			createAlreadyExists: "Der Tag kann nicht erstellt werden, weil bereits ein Tag mit diesem Namen existiert.",
			updateAlreadyExists: "Der Tag kann nicht aktualisiert werden, weil bereits ein Tag mit diesem Namen existiert.",
			created: "Tag erstellt",
			updated: "Tag aktualisiert",
			notFound: "Tag nicht gefunden",
			requiredFields: "Der Tag kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		tagsList: {
			newButton: "Neuer Tag",
			name: "Suchen nach Tag-Titel",
			deleteTag: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Lade Tag",
			headerLabel: "Tag",
			headerRelatedTags: "Verlinkte Tags",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			headerPublishedAt: "Veröffentlichungsdatum (publish date)",
			headerTagType: "Typ",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createTag: "Tag erstellen",
			headerStatus: "Status",
			type: "Typ",
			noEditTooltip: "Dieser Tag stammt ursprünglich vom {source}-Editor."
		},
		tags: {
			tagsLabel: "Tag",
			backButton: "Zur Tag-Liste",
			newTag: "Neuer Tag",
			messageDeleteTag: "Tag löschen",
			messageDeleteTagTitle: "Willst du diesen Tag wirklich löschen?",
			deleteTag: "Löschen",
			messageDeleted: "Tag gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Tags",
			errorFailedLoadedTagWithId: "Fehler beim Abrufen des Tags",
			handledInLegacySystem: "Dieser Tag wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			peopleTab: "Person bearbeiten",
			profile: "Steckbrief",
			imageSelector: "Bild auswählen oder hochladen"
		},
		tagsEdit: {
			title: "Tag-Titel",
			type: "Tag-Typ",
			counter: "Zähler",
			backButton: "Zur Tag-Liste",
			editTag: "Tag bearbeiten",
			messageSaved: "Tag gespeichert",
			linkTags: "Tags verlinken",
			urlSlug: "URL-Slug",
			pathConflictNotice: {
				template: "Dieser Pfad überschneidet sich mit {pathType} Pfad eines anderen Tags. Nur {pathRoutable} Tag ist erreichbar!",
				pathTypeCurrent: "dem aktuellen",
				pathTypeOld: "einem alten",
				pathRoutableThis: "dieser",
				pathRoutableOther: "der andere"
			},
			toTag: "Zum Tag",
			generatePath: "Pfad automatisch generieren",
			showOnListPage: "Auf Übersichtsseite anzeigen",
			publishSettings: "Veröffentlichungseinstellungen",
			publishDate: "Veröffentlichungsdatum (publish date)",
			unpublishDate: "Ablaufdatum",
			shownDate: "Anzeigedatum (display date)",
			deleteTag: "Löschen",
			duplicateTag: "Duplizieren",
			duplicateTagMessage: "Willst du diesen Tag wirklich duplizieren?",
			duplicate: "Duplizieren",
			takeOffline: "Depublizieren",
			selectTag: "Tag auswählen",
			nowLabel: "Auf jetzt einstellen",
			saveAsDraft: "Als Entwurf speichern",
			updateShownDate: "Anzeigedatum (display date) aktualisieren",
			updateShownDatePopup: "Anzeigedatum (display date) beim Speichern oder Veröffentlichen automatisch auf den aktuellen Zeitstempel aktualisieren.",
			modeUnpublished: "Tag depubliziert",
			modeScheduled: "Veröffentlichung geplant",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf"
		},
		tagType: {
			people: "Person",
			brand: "Marke"
		},
		tagsMigration: {
			directEditNotice: "Achtung: Die hier sichtbaren Einstellungen treten sofort in Kraft und werden unabhängig von der Speichern-Funktion wirksam.",
			source: "Ursprüngliches System",
			legacyId: "Legacy-ID",
			renderedByCtf: "Rendering durch CTF",
			editableInCtf: "Bearbeitbar in Vibe",
			modifiedInCtf: "Geändert in Vibe",
			confirmModal: {
				yes: "Ja",
				cancel: "Abbrechen",
				renderedBy: {
					title: "Toggle \"Rendering durch CTF\" ändern",
					message: "Willst du das Rendering-System wirklich ändern?"
				},
				editableIn: {
					title: "Toggle \"Bearbeitung in Vibe\" ändern",
					message: "Willst du die Bearbeitung in Vibe wirklich erlauben? Das kann nicht rückgängig gemacht werden."
				}
			},
			viewCtfVersion: "CTF-Version öffnen"
		}
	}
}, j = [{
	path: "/tags",
	children: [
		{
			path: "",
			name: "tags_list",
			component: () => import("./tags-list.view-wYWdEw8r.js").then((e) => e.n),
			meta: { requiredRight: "tags:navigate" }
		},
		{
			path: "new",
			name: "tags_new",
			component: () => import("./tags-edit.view-Cm189M8_.js"),
			props: () => ({
				title: x().t("tags.newTag"),
				backRoute: "/tags"
			}),
			meta: { requiredRight: ["tags:navigate"] }
		},
		{
			path: ":id",
			name: "tags_detail",
			component: () => import("./tags-edit.view-Cm189M8_.js"),
			props: (e) => ({
				title: x().t("tags.editTag"),
				id: e.params.id,
				backRoute: "/tags"
			}),
			meta: { requiredRight: ["tags:navigate"] }
		}
	]
}], M = /* @__PURE__ */ a(/* @__PURE__ */ f({
	__name: "tags-link-tags-button",
	props: { canEdit: {
		type: Boolean,
		default: !0
	} },
	emits: ["click:linkTags"],
	setup(e, { emit: t }) {
		let { t: n } = T(), r = t;
		return (t, i) => (m(), o(_(S), {
			"data-qa-tags-link-tags-button": "",
			disable: !e.canEdit,
			"text-color": "secondary",
			style: { "background-color": "white !important" },
			outline: "",
			class: "q-mr-sm linkTagsButton",
			onClick: i[0] ||= (e) => r("click:linkTags")
		}, {
			default: v(() => [u(_(C), {
				name: "plus",
				class: "q-mr-sm",
				color: "primary"
			}), l("span", null, g(_(n)("articlesEdit.linkTags")), 1)]),
			_: 1
		}, 8, ["disable"]));
	}
}), [["__scopeId", "data-v-d4022413"]]), N = { class: "relatedTagPill q-px-sm" }, P = /* @__PURE__ */ a(/* @__PURE__ */ f({
	__name: "tags-type-pill",
	props: { type: { default: "People" } },
	setup(e) {
		let t = e, n = () => i.find((e) => e.tagsType === t.type)?.icon || "help";
		return (t, r) => (m(), c("div", N, [u(_(C), {
			name: n(),
			class: "q-mr-sm q-my-auto",
			color: "white"
		}, null, 8, ["name"]), l("span", null, g(e.type), 1)]));
	}
}), [["__scopeId", "data-v-3f3ebf1a"]]), F = {
	key: 0,
	class: "relatedTagContainer q-mr-md q-mb-md",
	outlined: ""
}, I = {
	"data-qa-related-tag-image": "",
	class: "relatedTagImage"
}, L = { class: "relatedTagMiddle q-ml-md q-my-auto text-left" }, R = {
	"data-qa-related-tag-title": "",
	class: "relatedTagTitle q-ml-xs"
}, z = { class: "relatedTagDetails q-mr-sm q-ml-auto" }, B = /* @__PURE__ */ a(/* @__PURE__ */ f({
	__name: "tags-related-tag",
	props: { relatedTag: { default: "" } },
	emits: ["click:remove-tag"],
	setup(e, { emit: t }) {
		let r = t, i = h(), a, d = e;
		return p(async () => {
			if (d.relatedTag !== void 0) {
				try {
					i.value = await n(d.relatedTag);
				} catch (e) {
					console.error(e);
				}
				if (!i.value || i.value.state !== "publish") {
					r("click:remove-tag", d.relatedTag);
					return;
				}
				a = i.value?.pageMetadata?.imageUuid ? D(i.value.pageMetadata?.imageUuid ?? "", 100, 100) : "";
			}
		}), (t, n) => i.value ? (m(), c("div", F, [
			l("div", I, [_(a) === "" ? (m(), o(_(E), {
				key: 1,
				class: "custom-image"
			})) : (m(), o(_(w), {
				key: 0,
				"data-qa-preview": "",
				class: "custom-image",
				src: _(a)
			}, null, 8, ["src"]))]),
			l("div", L, [i.value.pageMetadata?.type ? (m(), o(P, {
				key: 0,
				"data-qa-related-tag-type": ""
			})) : s("", !0), l("span", R, g(i.value.title), 1)]),
			l("div", z, [i.value.brand ? (m(), o(_(y), {
				key: 0,
				class: "q-mx-md",
				brand: i.value.brand,
				small: ""
			}, null, 8, ["brand"])) : s("", !0), u(_(S), {
				icon: "close",
				flat: "",
				dense: "",
				class: "relatedTagRemoveButton",
				onClick: n[0] ||= (t) => r("click:remove-tag", e.relatedTag)
			})])
		])) : s("", !0);
	}
}), [["__scopeId", "data-v-cbe14dbd"]]), V = (e, t) => {
	let { hasCtfOverride: n } = t || {}, r = e.brand, i = b(r, e.state.toUpperCase()), a = "";
	if (e.pageMetadata === void 0) return "";
	a = e.state === "publish" ? e.paths && (e.paths.length ?? 0) > 0 && e.paths[e.paths.length - 1]?.path || "" : `themaPreview/_id_${e._id}.html`;
	let o = new URL(a, i);
	return n && o.searchParams.append("ctf", "override"), o.toString();
};
function H(e, t, n) {
	let r = k.sanitizeStringForUrl(e);
	return n === "bunte" ? `/thema/starprofile/${r}_${t}.html` : `/thema/person/${r}_${t}.html`;
}
//#endregion
//#region src/stores/tags.store.ts
var U = O("tagsStore", {
	state: () => ({
		loading: !1,
		tag: {
			publishDate: void 0,
			state: "draft",
			brand: "bunte",
			title: "",
			relatedTagsUuids: [],
			urlSlug: "",
			paths: [],
			contentsRef: [],
			pageMetadata: {
				type: "People",
				imageUuid: "",
				lastName: ""
			},
			legacy: {
				source: "vibe",
				isEditableInCTF: !0,
				hasBeenModifiedInCTF: !0,
				isRenderedByCTF: !0
			},
			showOnListPage: !1
		}
	}),
	actions: {
		async createTag() {
			if (this.tag._id) {
				this.loading = !0;
				try {
					return await this.updateTag(), this.tag._id;
				} finally {
					this.loading = !1;
				}
			}
			this.loading = !0;
			try {
				let { _id: e } = await r(this.tag);
				if (this.tag._id = e, this.tag.paths || (this.tag.paths = []), this.tag.urlSlug) {
					let t = H(this.tag.urlSlug, e, this.tag.brand);
					t !== this.tag.paths.at(-1)?.path && this.tag.paths.push({
						path: t,
						brand: this.tag.brand,
						type: this.isDefaultSlug() ? "generated" : "custom",
						createDate: /* @__PURE__ */ new Date()
					});
				}
				return await this.updateTag(), e;
			} finally {
				this.loading = !1;
			}
		},
		async updateTag() {
			if (this.tag._id) {
				if (this.loading = !0, this.tag.paths || (this.tag.paths = []), this.tag.urlSlug) {
					let e = H(this.tag.urlSlug, this.tag._id, this.tag.brand);
					e !== this.tag.paths.at(-1)?.path && this.tag.paths.push({
						brand: this.tag.brand,
						path: e,
						type: this.isDefaultSlug() ? "generated" : "custom",
						createDate: /* @__PURE__ */ new Date()
					});
				}
				(this.tag.displayDate === void 0 || this.tag.publishDate && this.tag.displayDate < this.tag.publishDate) && (this.tag.displayDate = this.tag.publishDate), this.tag.publishDate && this.tag.publishDate > /* @__PURE__ */ new Date() && (this.tag.state = "schedule"), this.tag.legacy.hasBeenModifiedInCTF = !0;
				try {
					await t({
						...this.tag,
						_id: this.tag._id
					});
				} finally {
					this.loading = !1;
				}
			}
		},
		async duplicateTag() {
			this.loading = !0;
			let e = {
				state: "draft",
				brand: "bunte",
				title: "",
				relatedTagsUuids: this.tag.relatedTagsUuids,
				pageMetadata: this.tag.pageMetadata,
				paths: [],
				contentsRef: this.tag.contentsRef,
				legacy: this.tag.legacy,
				showOnListPage: this.tag.showOnListPage
			};
			try {
				await r(e);
			} finally {
				this.loading = !1;
			}
		},
		async deleteTag() {
			if (this.tag._id) {
				this.loading = !0;
				try {
					await e(this.tag._id);
				} finally {
					this.loading = !1;
				}
			}
		},
		async unpublishTag() {
			if (this.tag._id) {
				this.tag.state = "unpublish", this.tag.publishDate = void 0, this.tag.unpublishDate = /* @__PURE__ */ new Date(), this.loading = !0;
				try {
					await t({
						...this.tag,
						_id: this.tag._id
					});
				} finally {
					this.loading = !1;
				}
			}
		},
		updateBlocksArray(e) {
			this.tag.contentsRef = e;
		},
		getDefaultSlug() {
			return this.tag.title.toLowerCase().replace(/ /g, "-");
		},
		isDefaultSlug() {
			return this.getDefaultSlug() === this.tag.urlSlug;
		}
	}
}), W = d(() => import("./people-profile-block-90tc_5D_.js")), G = d(() => import("./tags-list.view-wYWdEw8r.js").then((e) => e.n)), K = {
	messages: A,
	routes: j,
	contentBlocks: [{
		type: "PEOPLE_PROFILE",
		label: "tags.profile",
		icon: "star",
		component: W,
		defaultValue: {
			type: "PEOPLE_PROFILE",
			imageUuid: "",
			lastName: ""
		}
	}]
};
//#endregion
export { V as a, U as i, G as n, B as o, K as r, M as s, W as t };

//# sourceMappingURL=src-UoL79N4N.js.map